var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("base-dialog", {
        attrs: { content: _vm.$store.state.dialogMsg },
        model: {
          value: _vm.dialogVisible,
          callback: function($$v) {
            _vm.dialogVisible = $$v
          },
          expression: "dialogVisible"
        }
      }),
      _vm._v(" "),
      _c(
        "base-modal",
        {
          on: {
            hidden: function($event) {
              _vm.todayHealthConditionGraphVisible = false
            }
          },
          model: {
            value: _vm.todayHealthConditionGraphVisible,
            callback: function($$v) {
              _vm.todayHealthConditionGraphVisible = $$v
            },
            expression: "todayHealthConditionGraphVisible"
          }
        },
        [
          _c("clinic-history-variable-chart", {
            attrs: {
              coloringPoints: "",
              variableName: _vm.HEALTH_CONDITION_TODAY,
              dynamicXAxis: "",
              oneValuePerDay: "",
              label: _vm.$t("patient-panel.health-condition-graph-label"),
              maxValue: 10
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showHealthSliderModal
        ? _c("health-sliders-modal", {
            attrs: {
              variables: [_vm.HEALTH_CONDITION_TODAY],
              showTitle: false,
              hideFooter: ""
            },
            on: { save: _vm.onTodayHealthConditionSave }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row landing-cnt panel-cnt" }, [
        _c(
          "div",
          { staticClass: "col-12 my-lg-auto my-0 logged-ctn" },
          [
            _c(
              "div",
              {
                staticClass: "logged-title-ctn mb-4 mb-xl-6 mx-auto text-center"
              },
              [
                _c("h1", { staticClass: "mb-4 panel" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("patient-panel.welcome", {
                        platform: _vm.getPlatformName
                      })
                    )
                  )
                ]),
                _vm._v(" "),
                _vm.$store.state.session.user &&
                _vm.$store.getters["session/userHasCompanies"]
                  ? _c(
                      "base-button",
                      {
                        staticClass: "one-liner-btn",
                        attrs: { variant: "success" },
                        on: { click: _vm.onTodayHealthConditionButtonClick }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.$t("patient-panel.how-do-you-feel-today", {
                                name: _vm.$store.state.session.user.firstName
                              })
                            ) +
                            "\n\t\t\t\t\t"
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("PatientPanelBlocks")
          ],
          1
        ),
        _vm._v(" "),
        !_vm.$store.getters["session/isLogged"]
          ? _c(
              "div",
              {
                staticClass: "learn-more",
                on: {
                  click: function($event) {
                    return _vm.goToSection("integral-solutions")
                  }
                }
              },
              [_c("span", [_vm._v(_vm._s(_vm.$t("learn-more-btn")))])]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "base-dialog",
        {
          attrs: {
            okBtnVisible: false,
            cancelFn: function() {
              _vm.showSurveyDialog = false
            },
            dontShowAgainCookie: _vm.surveyDialogKey,
            hideFooter: _vm.hideSurveyDialogFooter
          },
          model: {
            value: _vm.showSurveyDialog,
            callback: function($$v) {
              _vm.showSurveyDialog = $$v
            },
            expression: "showSurveyDialog"
          }
        },
        [
          _c(
            "div",
            { staticClass: "survey-content" },
            [
              _c("SurveyTest", {
                attrs: { surveyIdProp: _vm.surveyAvailable },
                on: {
                  surveyCompleted: _vm.handleSurveyCompletion,
                  surveyStarted: _vm.handleSurveyStarted
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53d7b628", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53d7b628","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/patient/Panel.vue
// module id = 3939
// module chunks = 38